// tslint:disable
/**
 * LXBackend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists } from '../runtime';
/**
 * 
 * @export
 * @interface ClassroomJoinRequest
 */
export interface ClassroomJoinRequest {
    /**
     * 
     * @type {string}
     * @memberof ClassroomJoinRequest
     */
    joinCode?: string;
}

export function ClassroomJoinRequestFromJSON(json: any): ClassroomJoinRequest {
    return {
        'joinCode': !exists(json, 'join_code') ? undefined : json['join_code'],
    };
}

export function ClassroomJoinRequestToJSON(value?: ClassroomJoinRequest): any {
    if (value === undefined) {
        return undefined;
    }
    return {
        'join_code': value.joinCode,
    };
}


